/** Pages WITHOUT `getLayout`: the customer shell (LayoutProvider → CustomerLayout). */
import { createFileRoute, Outlet } from '@tanstack/react-router'

import { AppErrorBoundary } from '@/components/app-error-boundary'
import { LayoutProvider } from '@/layouts/LayoutProvider'

export const Route = createFileRoute('/_shell')({
  component: () => (
    <LayoutProvider>
      <AppErrorBoundary>
        <Outlet />
      </AppErrorBoundary>
    </LayoutProvider>
  ),
})
